module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "data-vv-scope": "formWebhookSettings"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit('formWebhookSettings')
      }
    }
  }, [_c('description-webhook-settings'), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select-webhook-settings'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('authorized-link', {
    attrs: {
      "tag": "show_setting"
    }
  }, [_c('label', {
    staticClass: "ls-label"
  }, [_c('span', {
    staticClass: "ls-label-text col-xs-12"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('settings.main.webhook_setting_url')) + "\n              "), _c('popover', {
    staticClass: "mb-1",
    attrs: {
      "position": 'right'
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v(_vm._s(_vm.$t('settings.tooltip.webhook_setting')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-7 col-sm-7 col-lg-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.webhookSetting.value),
      expression: "webhookSetting.value"
    }],
    attrs: {
      "type": "url",
      "required": false,
      "min": 1,
      "max": 30,
      "name": _vm.$t('settings.main.webhook_setting_value'),
      "placeholder": _vm.$t('settings.placeholder.webhook_setting_value')
    },
    domProps: {
      "value": (_vm.webhookSetting.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.webhookSetting.value = $event.target.value
      }
    }
  })])])])], 1)], 1), _vm._v(" "), _c('button-submit')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69e23f2b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/settings/components/WebhookSettings.vue
// module id = 795
// module chunks = 1